<template>
  <div class="wrapper">
    <img class="pic" src="https://picsum.photos/800/800" alt="" />
    <div class="login-content">
      <!-- 登录表单 -->
      <template v-if="!showUserSelect">
        <p class="title">登录仓颉</p>
        <div>
          <a-input
            placeholder="用户名"
            v-model:value="username"
            ref="userNameInput"
            @keyup.enter="login"
          >
            <template #prefix>
              <user-outlined style="color: rgba(0, 0, 0, 0.25)" />
            </template>
          </a-input>
          <div class="gap8"></div>
          <a-input-password 
            v-model:value="password" 
            placeholder="密码"
            @keyup.enter="login"
          >
            <template #prefix>
              <lock-outlined style="color: rgba(0, 0, 0, 0.25)" />
            </template>
          </a-input-password>
        </div>
        <div class="gap8"></div>
        <div class="gap8"></div>
        <a-button type="primary" @click="login" :loading="loading" block>登录 →</a-button>
      </template>

      <!-- 用户选择（超级管理员登录后） -->
      <template v-else>
        <p class="title">选择用户</p>
        <a-input-search
          v-model:value="searchKeyword"
          placeholder="搜索用户"
          style="margin-bottom: 12px;"
        />
        <div class="user-list">
          <div 
            v-for="user in filteredUsers" 
            :key="user.objectId"
            class="user-item"
            @click="selectUser(user)"
          >
            <user-outlined style="margin-right: 8px;" />
            {{ user.username }}
            <a-tag v-if="user.is_super" color="gold" style="margin-left: 8px;">管理员</a-tag>
          </div>
        </div>
        <div class="gap8"></div>
        <a-button @click="enterAsAdmin" block>以管理员身份进入</a-button>
        <div class="gap8"></div>
        <a-button type="link" @click="backToLogin" block>返回登录</a-button>
      </template>
    </div>
  </div>
</template>
<script>
import {
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons-vue";

export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      showUserSelect: false,
      users: [],
      searchKeyword: "",
    };
  },
  components: {
    UserOutlined,
    LockOutlined,
  },
  computed: {
    filteredUsers() {
      if (!this.searchKeyword) return this.users;
      const keyword = this.searchKeyword.toLowerCase();
      return this.users.filter(u => 
        u.username.toLowerCase().includes(keyword)
      );
    },
  },
  methods: {
    login() {
      (async () => {
        await this._login();
      })();
    },
    async _login() {
      if (!this.username) {
        return this.$message.error('请输入用户名');
      }
      if (!this.password) {
        return this.$message.error('请输入密码');
      }
      
      this.loading = true;
      
      try {
        const user = await this.$lc.User.logIn(this.username, this.password);
        this.$user = user;
        
        // 超级管理员显示用户选择
        if (user.get('is_super')) {
          await this.loadUsers();
          this.showUserSelect = true;
        } else {
          this.$message.success("登录成功");
          this.$router.push("/");
        }
      } catch (error) {
        this.$message.error(error.message || "登录失败");
      } finally {
        this.loading = false;
      }
    },
    async loadUsers() {
      try {
        this.users = await this.$lc.User.fetchUsers();
      } catch (error) {
        this.$message.error('加载用户列表失败');
      }
    },
    async selectUser(user) {
      if (user.is_super) {
        this.enterAsAdmin();
        return;
      }
      try {
        const switchedUser = await this.$lc.User.switchUser(user.username);
        this.$user = switchedUser;
        this.$message.success(`已切换到: ${user.username}`);
        this.$router.push("/");
      } catch (error) {
        this.$message.error(error.message || "切换失败");
      }
    },
    enterAsAdmin() {
      this.$message.success("登录成功");
      this.$router.push("/");
    },
    backToLogin() {
      this.$lc.User.logOut();
      this.showUserSelect = false;
      this.username = "";
      this.password = "";
      this.searchKeyword = "";
    },
  },
};
</script>
<style lang="css" scoped>
.gap8 { height: 8px; }

.wrapper {
  background: #f0f2f5;
  display: flex;
  align-items: center;
}

.pic {
  display: block;
  width: 100vh;
  height: 100vh;
}

.login-content {
  margin: 0 auto;
  min-width: 360px;
  position: relative;
  top: -10vh;
  text-align: center;
}

.title {
  font: 24px bold;
  margin-bottom: 16px;
}

.user-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
}

.user-item {
  padding: 10px 16px;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.user-item:last-child {
  border-bottom: none;
}

.user-item:hover {
  background: #e6f7ff;
}
</style>
